import { icons } from "../../constants/icons";

export const IconOperations = {
  isIcon: (arg) => {
    let matcher = /\bic-/;
    return matcher.test(arg);
  },

  icon: (arg) => {
    let matcher = /\bic-/;
    // can only have a mx of 3 things: num, color, size
    arg = arg.replace(matcher, "");
    let args = arg.split("-");
    if (args.length > 3) {
      console.log("Will throw error, property unknown");
    }
    console.log(args, "here")
    let stringBuildOpen = ` <i data-feather=`;
    let stringBuildClose = ` "></i>`;
    if (args[0]) {
      // num ref from all.js
      try {
        let num = Number(args[0]);
        stringBuildOpen += `"${icons[num]}"`;
      } catch (e) {
        console.log("Not a num error ---");
      }
    }
    if (args[1]) {
      // this should be a color
      // if color is not hex and not in default colors, throw error. Otherwise create style
      stringBuildOpen += ` style="color: ${args[1]} `;
    }
    if (args[2]) {
      // should be the size of the icon
      try {
        let num = Number(args[2]);
        stringBuildOpen += ` ;width: ${num*10}px; height: ${num*10};`;
      } catch (e) {
        console.log("Will throw errors");
      }
    }
    stringBuildOpen += stringBuildClose;
    return stringBuildOpen
  },
};

export const runIconOperations = (readLinesOriginal, readLines, errors) => {
    for(let i =0; i < readLines.length; i++){
        let x = readLines[i];
        if(IconOperations.isIcon(x)){
            readLines[i] = IconOperations.icon(x);
            console.log(readLines[i])
        }
    }
    return readLines;
}
